import dayjs from 'dayjs';

export const useDefaultDateTime = () => {
  const passHalf = dayjs().minute() >= 30;

  return dayjs()
    .add(passHalf ? 2 : 1, 'hour')
    .startOf('hour')
    .toISOString();
};
